export default "__VITE_ASSET__KUNjcl31__";